import z from 'zod';

export const kidProfileSchema = z.object({
  kids: z.preprocess((val) => val === 'true' || val === true, z.boolean()).default(false),
});
